import { useContext } from 'react';
import { RestaurantContext } from '../contexts/RestaurantContext';

// ----------------------------------------------------------------------

const useRestaurants = () => useContext(RestaurantContext);

export default useRestaurants;
